import TypographyParagraph from '../../typography/TypographyParagraph'
import { Tooltip, TooltipRefProps } from 'react-tooltip'
import { useRef } from 'react'
import { truncateStringInMiddle } from '#app/utils/misc.tsx'
import ProofOfExhibitionTemplate from './proofOfExhibitionTemplate.tsx'
import MediaCitationTemplate from './mediaCitationTemplate.tsx'
import CommentTemplate from './commentTemplate.tsx'
import TweetTemplate from './tweetTemplate.tsx'
import CastTemplate from './castTemplate.tsx'
import OffchainLendTemplate from './offchainLendTemplate.tsx'
import OffchainSaleTemplate from './offchainSaleTemplate.tsx'
import InstagramTemplate from './instagramTemplate.tsx'

export default function CountersignTemplate({
	countersign,
}: {
	countersign: any
}) {
	const tooltipCopyDescription = useRef<TooltipRefProps>(null)
	const tooltipCopyoriginalAttestationSignature = useRef<TooltipRefProps>(null)
	const tooltipCopyExhibitionName = useRef<TooltipRefProps>(null)
	const toolTipCopyOriginalStartDate = useRef<TooltipRefProps>(null)
	const tooltipCopyEndDate = useRef<TooltipRefProps>(null)
	const tooltipCopyOwnerWallet = useRef<TooltipRefProps>(null)
	const tooltipCopyExhibitionWallet = useRef<TooltipRefProps>(null)
	const tooltipCopyExhibitionLocation = useRef<TooltipRefProps>(null)
	const tooltipCopyExternalLink = useRef<TooltipRefProps>(null)
	const tooltipCopyExhibitionDetails = useRef<TooltipRefProps>(null)
	const tooltipCopySignature = useRef<TooltipRefProps>(null)
	return (
		<>
			{countersign.properties.description && (
				<div
					id="title"
					className="flex flex-row justify-between border-b border-textInactiveLight p-4 hover:bg-uiSecondaryLight dark:border-textInactiveDark dark:hover:bg-uiSecondaryDark"
					onClick={() => {
						navigator.clipboard.writeText(countersign.properties.description)
						tooltipCopyDescription.current?.open({
							anchorSelect: '#title',
							content: 'Copied!',
						})
						setTimeout(() => {
							tooltipCopyDescription.current?.close()
						}, 2000)
					}}
				>
					<Tooltip imperativeModeOnly ref={tooltipCopyDescription} />
					<TypographyParagraph
						size="medium"
						additionalClasses="text-textSecondaryLight dark:text-textSecondaryDark"
					>
						Description:
					</TypographyParagraph>
					<TypographyParagraph
						size="medium"
						additionalClasses="ml-2 text-textPrimaryLight dark:text-textPrimaryDark"
					>
						{countersign.properties.description}
					</TypographyParagraph>
				</div>
			)}
			{countersign.originalReference.template.name && (
				<div
					id="title"
					className="flex flex-row justify-between border-b border-textInactiveLight p-4 hover:bg-uiSecondaryLight dark:border-textInactiveDark dark:hover:bg-uiSecondaryDark"
				>
					<Tooltip imperativeModeOnly />
					<TypographyParagraph
						size="medium"
						additionalClasses="text-textSecondaryLight dark:text-textSecondaryDark"
					>
						Countersigned Attestation:
					</TypographyParagraph>
					<TypographyParagraph
						size="medium"
						additionalClasses="ml-2 text-textPrimaryLight dark:text-textPrimaryDark"
					>
						{countersign.originalReference.template.name}
					</TypographyParagraph>
				</div>
			)}
			{countersign.properties.originalAttestationIPFSCID && (
				<div
					id="originalSignature"
					className="flex flex-row justify-between p-4 hover:bg-uiSecondaryLight dark:hover:bg-uiSecondaryDark"
					onClick={() => {
						navigator.clipboard.writeText(
							countersign.originalReference.signature,
						)
						tooltipCopyoriginalAttestationSignature.current?.open({
							anchorSelect: '#originalSignature',
							content: 'Copied!',
						})
						setTimeout(() => {
							tooltipCopyoriginalAttestationSignature.current?.close()
						}, 2000)
					}}
				>
					<Tooltip
						imperativeModeOnly
						ref={tooltipCopyoriginalAttestationSignature}
					/>
					<TypographyParagraph
						size="medium"
						additionalClasses="text-textSecondaryLight dark:text-textSecondaryDark"
					>
						Original Attestation Signature:
					</TypographyParagraph>
					<TypographyParagraph
						size="medium"
						additionalClasses="ml-2 text-textPrimaryLight dark:text-textPrimaryDark break-all"
					>
						{countersign.originalReference.signature}
					</TypographyParagraph>
				</div>
			)}
			{countersign.originalReference &&
				countersign.originalReference.properties && (
					<div className="border-t border-textInactiveLight dark:border-textInactiveDark">
						{countersign.originalReference.template.slug ===
							'proofOfExhibition' && (
							<ProofOfExhibitionTemplate
								proofOfExhibition={{
									...countersign.originalReference,
									isReattested: true,
									signature: countersign.signature,
								}}
							/>
						)}
						{countersign.originalReference.template.slug === 'comment' && (
							<CommentTemplate
								comment={{
									...countersign.originalReference,
									signature: countersign.signature,
								}}
							/>
						)}
						{countersign.originalReference.template.slug ===
							'mediaCitation' && (
							<MediaCitationTemplate
								mediaCitation={{
									...countersign.originalReference,
									signature: countersign.signature,
								}}
							/>
						)}
						{countersign.originalReference.template.slug === 'tweet' && (
							<TweetTemplate
								tweet={{
									...countersign.originalReference,
									signature: countersign.signature,
								}}
							/>
						)}
						{countersign.originalReference.template.slug === 'cast' && (
							<CastTemplate
								cast={{
									...countersign.originalReference,
									signature: countersign.signature,
								}}
							/>
						)}
						{countersign.originalReference.template.slug === 'instagram' && (
							<InstagramTemplate
								instagram={{
									...countersign.originalReference,
									signature: countersign.signature,
								}}
							/>
						)}
						{countersign.originalReference.template.slug === 'offchainLend' && (
							<OffchainLendTemplate
								offchainLend={{
									...countersign.originalReference,
									isReattested: true,
									signature: countersign.signature,
								}}
							/>
						)}
						{countersign.originalReference.template.slug === 'offchainSale' && (
							<OffchainSaleTemplate
								offchainSale={{
									...countersign.originalReference,
									signature: countersign.signature,
								}}
							/>
						)}
					</div>
				)}
		</>
	)
}
